// export * from './useRoleDetail';
export * from './useRoleDetail2';
